import React from 'react';

const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <h2 className="section-title">Cómo Funciona</h2>
        <p className="section-subtitle">Experimenta transparencia completa en el viaje de siembra de tu árbol</p>

        <div className="process-timeline">
          <div className="process-step">
            <div className="step-number">1</div>
            <div className="step-icon">💳</div>
            <div className="step-content">
              <h3>Elige y Paga</h3>
              <p>Selecciona tus árboles y paga de forma segura online o con transferencias bancarias colombianas</p>
            </div>
          </div>

          <div className="timeline-connector"></div>

          <div className="process-step">
            <div className="step-number">2</div>
            <div className="step-icon">📧</div>
            <div className="step-content">
              <h3>Accede a tu Portal</h3>
              <p>Recibe notificación por email con acceso de login a tu portal personal para seguimiento en tiempo real</p>
            </div>
          </div>

          <div className="timeline-connector"></div>

          <div className="process-step">
            <div className="step-number">3</div>
            <div className="step-icon">👨‍🌾</div>
            <div className="step-content">
              <h3>Conoce a tu Sembrador</h3>
              <p>Te presentamos al trabajador de campo asignado que plantará tu árbol</p>
            </div>
          </div>

          <div className="timeline-connector"></div>

          <div className="process-step">
            <div className="step-number">4</div>
            <div className="step-icon">🔔</div>
            <div className="step-content">
              <h3>Notificación de Siembra</h3>
              <p>Recibe un email cuando tu árbol sea plantado</p>
            </div>
          </div>

          <div className="timeline-connector"></div>

          <div className="process-step">
            <div className="step-number">5</div>
            <div className="step-icon">📍</div>
            <div className="step-content">
              <h3>Ubicación GPS</h3>
              <p>Recibe las coordenadas GPS exactas de tu árbol con vista de mapa satelital</p>
            </div>
          </div>

          <div className="timeline-connector"></div>

          <div className="process-step">
            <div className="step-number">6</div>
            <div className="step-icon">📸</div>
            <div className="step-content">
              <h3>Prueba Fotográfica</h3>
              <p>Obtén fotos profesionales de siembra</p>
            </div>
          </div>

          <div className="timeline-connector"></div>

          <div className="process-step">
            <div className="step-number">7</div>
            <div className="step-icon">🌱</div>
            <div className="step-content">
              <h3>Actualizaciones y Visitas</h3>
              <p>Ordena actualizaciones fotográficas opcionales para ver el crecimiento de tu árbol o programa visitas en persona a tu bosque</p>
            </div>
          </div>
        </div>

        <div className="transparency-highlight">
          <div className="highlight-icon">✨</div>
          <p>Tu conexión única: A diferencia de otras organizaciones, tú sigues TU árbol específico desde la compra hasta la madurez con coordenadas GPS precisas, fotos reales y acceso 24/7 a su progreso.</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
